import React, { useContext } from 'react';

import {
  FleetFiltersContextProvider,
  defaultFilters as fleetDefaultFilters,
} from 'modules/fleet/filters/context';

import DispatchingFiltersContext, {
  DispatchingFiltersContextProvider,
  dispatchingDefaultFilters,
} from 'modules/dispatching/filters/context';

import { DispatchingUIProvider } from 'modules/dispatching/ui';
import { DispatchingServiceContextProvider } from 'modules/dispatching/service';
import { SetToManualFlowContextProvider } from 'modules/set-to-manual-flow/context';
import { AssignmentContextProvider } from 'modules/dispatching/assignment/context';
import AssignmentEventEmitter from 'modules/dispatching/assignment/events';
import RootProvider from 'utils/tests';
import { RoutingEventEmitter, RoutingContextProvider } from 'modules/routing';

const DispatchingProviderWithFilter = ({ children }) => {
  const { filters } = useContext(DispatchingFiltersContext);

  return (
    <DispatchingServiceContextProvider filters={filters}>
      {children}
    </DispatchingServiceContextProvider>
  );
};

const DispatchingProvider = ({ children }) => {
  return (
    <DispatchingUIProvider>
      <SetToManualFlowContextProvider model="itinerary">
        <DispatchingFiltersContextProvider defaultFilters={dispatchingDefaultFilters}>
          <DispatchingProviderWithFilter>{children}</DispatchingProviderWithFilter>
        </DispatchingFiltersContextProvider>
      </SetToManualFlowContextProvider>
    </DispatchingUIProvider>
  );
};

const DispatchingTestsProvider = ({ children }) => (
  <RootProvider>
    <RoutingContextProvider eventEmitter={RoutingEventEmitter}>
      <AssignmentContextProvider eventEmitter={AssignmentEventEmitter}>
        <FleetFiltersContextProvider defaultFilters={fleetDefaultFilters}>
          <DispatchingProvider>{children}</DispatchingProvider>
        </FleetFiltersContextProvider>
      </AssignmentContextProvider>
    </RoutingContextProvider>
  </RootProvider>
);

export { DispatchingProvider, DispatchingTestsProvider };
